<app-header />
<div class="gallary">
    <div class="gallary_top bg_1 inline_padding1 p-top-132">
        <div class="gallary_top_flex">
            <div class="text_blue_5 p-y-18 cursor-pointer" routerLink="/">
                <a>Home</a>
            </div>
            <div class="p-l-16 p-y-18">
                <svg width="7" height="8" viewBox="0 0 7 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M1.31367 7.85721L6.7222 4.44452C6.80933 4.38951 6.87927 4.32127 6.92722 4.24449C6.97517 4.1677 7 4.08419 7 3.99968C7 3.91517 6.97517 3.83165 6.92722 3.75487C6.87927 3.67809 6.80933 3.60985 6.7222 3.55484L1.31367 0.142143C0.797419 -0.18355 0 0.0864778 0 0.58698L0 7.41335C0 7.91386 0.797419 8.18388 1.31367 7.85721Z"
                        fill="#303030" />
                </svg>
            </div>
            <div class="text_blue_5 p-l-16 p-y-18 cursor-pointer" routerLink="/gallery">
                <a>Gallery</a>
            </div>
            <div class="p-l-16 p-y-18">
                <svg width="7" height="8" viewBox="0 0 7 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M1.31367 7.85721L6.7222 4.44452C6.80933 4.38951 6.87927 4.32127 6.92722 4.24449C6.97517 4.1677 7 4.08419 7 3.99968C7 3.91517 6.97517 3.83165 6.92722 3.75487C6.87927 3.67809 6.80933 3.60985 6.7222 3.55484L1.31367 0.142143C0.797419 -0.18355 0 0.0864778 0 0.58698L0 7.41335C0 7.91386 0.797419 8.18388 1.31367 7.85721Z"
                        fill="#303030" />
                </svg>
            </div>
            <div class="text_black_8 p-l-16 p-y-18 ">
                <span>{{ galleryDetails?.title || 'Album View' }}</span>
            </div>
        </div>
    </div>
    <div class="bg_2 p-x-100 top_padding2 gallary_bottom ">

        <div class="dis-flex gallary_bottom_head">
            <div class="gallary_bottom_head_img">
                <img [src]="getImageUrl(galleryDetails)" class="gallary_bottom_head_img_logo width-50-per" />
            </div>
            <div class="p-l-32">
                <p class="text_black_7">{{ galleryDetails?.title }}</p>
                <div class="text_style_9 text_align-justify" [innerHTML]="galleryDetails?.description"></div>
                <!-- <div class="p-top-8 text-wrap" *ngIf="galleryDetails.web_link">
                    
                        <span class="text_black_10">Weblink: </span>
                    
                    <a [href]="galleryDetails.web_link" class="text_blue_14" target="_blank">
                        {{ galleryDetails.web_link }}
                    </a>
                </div> -->
                <div class="p-top-12" style="display: flex; justify-content: flex-start;">
                    <button type="button" class="rounded-pill text_white_1 button_blue_7"
                        (click)="openLink(getGalleryWebLink(galleryDetails))"
                        style="width: 150px; padding: 12px 24px; display: flex; justify-content: space-between; align-items: center; border: 0;">
                        <span class="button_blue_1_text" style="font-size: 16px;">Weblink</span>
                        <img class="button_blue_1_text_icon" src="../../../assets/icons/arrow-right.png"
                            style="height: 14px; max-width: none; object-fit: contain; margin-left: 10px;" />
                    </button>
                </div>
            </div>
        </div>

        <div class="p-y-60 gallary_bottom_box" *ngIf="getDetails.length > 0">

            <!-- Fifth Div (Complex Grid Layout) -->
            <div class="gallary_bottom_box_body1" *ngIf="div5Images.length > 0">
                <div class="dis-block-2 gallary_bottom_box_body1_two">
                    <div class="gallary_bottom_box_body1_two_inner">
                        <div class="border-radius-6 gallary_bottom_box_body1_two_inner_content">
                            <img class="width-100-per height-100-per" [src]="getImageUrl(div5Images[1])" />
                        </div>
                    </div>
                    <div class="p-top-40 gallary_bottom_box_body1_two_inner">
                        <div class="border-radius-6 gallary_bottom_box_body1_two_inner_content">
                            <img [src]="getImageUrl(div5Images[2])" class="width-100-per height-100-per" />
                        </div>
                    </div>
                </div>
                <div class="gallary_bottom_box_body1_one">
                    <div class="border-radius-6 gallary_bottom_box_body1_one_inner">
                        <img class="width-100-per height-100-per" [src]="getImageUrl(div5Images[0])" />
                    </div>
                </div>
                <div class="dis-block-2 gallary_bottom_box_body1_two">
                    <div class="gallary_bottom_box_body1_two_inner">
                        <div class="border-radius-6 gallary_bottom_box_body1_two_inner_content">
                            <img class="width-100-per height-100-per" [src]="getImageUrl(div5Images[3])" />
                        </div>
                    </div>
                    <div class="p-top-40 gallary_bottom_box_body1_two_inner">
                        <div class="border-radius-6 gallary_bottom_box_body1_two_inner_content">
                            <img [src]="getImageUrl(div5Images[4])" class="width-100-per height-100-per" />
                        </div>
                    </div>
                </div>
            </div>

            <!-- Iterate over sets of 4 images for div4 -->
            <ng-container *ngFor="let div4Images of div4ImagesSets">
                <div class="gallary_bottom_box_body1">
                    <div class="gallary_bottom_box_body1_one">
                        <div class="border-radius-6 gallary_bottom_box_body1_one_inner">
                            <img class="width-100-per height-100-per" [src]="getImageUrl(div4Images[0])" />
                        </div>
                    </div>
                    <div class="dis-block-2 gallary_bottom_box_body1_two">
                        <div class="gallary_bottom_box_body1_two_inner">
                            <div class="border-radius-6 gallary_bottom_box_body1_two_inner_content">
                                <img class="width-100-per height-100-per" [src]="getImageUrl(div4Images[1])" />
                            </div>
                        </div>
                        <div class="p-top-40 gallary_bottom_box_body1_two_inner">
                            <div class="border-radius-6 gallary_bottom_box_body1_two_inner_content">
                                <img [src]="getImageUrl(div4Images[2])" class="width-100-per height-100-per" />
                            </div>
                        </div>
                    </div>
                    <div class="gallary_bottom_box_body1_one">
                        <div class="border-radius-6 gallary_bottom_box_body1_one_inner">
                            <img [src]="getImageUrl(div4Images[3])" class="width-100-per height-100-per" />
                        </div>
                    </div>
                </div>
            </ng-container>

            <!-- First Div (Single Image Display) -->
            <div *ngIf="div1Images.length > 0">
                <div *ngFor="let image of div1Images" class="dis-flex-2 border-radius-6">
                    <img [src]="getImageUrl(image)" class="width-100-per height-100-per" />
                </div>
            </div>

            <!-- Second Div (Grid of 2 Images) -->
            <div class="dis-grid-2" *ngIf="div2Images.length > 0">
                <div class="gallary_bottom_box_body1_one p-r-10" *ngIf="div2Images[0]">
                    <div class="border-radius-6 gallary_bottom_box_body1_one_inner">
                        <img [src]="getImageUrl(div2Images[0])" class="width-100-per height-100-per" />
                    </div>
                </div>
                <div class="gallary_bottom_box_body1_one p-l-10" *ngIf="div2Images.length > 1">
                    <div class="border-radius-6 gallary_bottom_box_body1_one_inner">
                        <img [src]="getImageUrl(div2Images[1])" class="width-100-per height-100-per" />
                    </div>
                </div>
            </div>

            <!-- Third Div (Grid of 1 Image per Row) -->
            <div class="dis-grid-1" *ngIf="div3Images.length > 0">
                <div class="gallary_bottom_box_body1_one" *ngIf="div3Images[0]">
                    <div class="border-radius-6 gallary_bottom_box_body1_one_inner">
                        <img [src]="getImageUrl(div3Images[0])" class="width-100-per height-100-per" />
                    </div>
                </div>
                <div class="gallary_bottom_box_body1_one p-l-40 p-r-40" *ngIf="div3Images.length > 1">
                    <div class="border-radius-6 gallary_bottom_box_body1_one_inner">
                        <img [src]="getImageUrl(div3Images[1])" class="width-100-per height-100-per" />
                    </div>
                </div>
                <div class="gallary_bottom_box_body1_one" *ngIf="div3Images[2]">
                    <div class="border-radius-6 gallary_bottom_box_body1_one_inner">
                        <img [src]="getImageUrl(div3Images[2])" class="width-100-per height-100-per" />
                    </div>
                </div>
            </div>
        </div>




    </div>

    <app-footer />

    <!-- Fivth Div (Complex Grid Layout) -->
    <!-- <div class="gallary_bottom_box_body1" *ngIf="div5Images.length > 0">
                <div class="dis-block-2 gallary_bottom_box_body1_two">
                    <div class="gallary_bottom_box_body1_two_inner">
                        <div class="border-radius-6 gallary_bottom_box_body1_two_inner_content">
                            <img class="width-100-per height-100-per" [src]="imgbaseurl + div5Images[1]?.image" />
                        </div>
                    </div>
                    <div class="p-top-40 gallary_bottom_box_body1_two_inner">
                        <div class="border-radius-6 gallary_bottom_box_body1_two_inner_content">
                            <img [src]="imgbaseurl + div5Images[2]?.image" class="width-100-per height-100-per" />
                        </div>
                    </div>
                </div>
                <div class="gallary_bottom_box_body1_one">
                    <div class="border-radius-6 gallary_bottom_box_body1_one_inner">
                        <img class="width-100-per height-100-per" [src]="imgbaseurl + div5Images[0]?.image" />
                    </div>
                </div>
                <div class="dis-block-2 gallary_bottom_box_body1_two">
                    <div class="gallary_bottom_box_body1_two_inner">
                        <div class="border-radius-6 gallary_bottom_box_body1_two_inner_content">
                            <img class="width-100-per height-100-per" [src]="imgbaseurl + div5Images[1]?.image" />
                        </div>
                    </div>
                    <div class="p-top-40 gallary_bottom_box_body1_two_inner">
                        <div class="border-radius-6 gallary_bottom_box_body1_two_inner_content">
                            <img [src]="imgbaseurl + div5Images[2]?.image" class="width-100-per height-100-per" />
                        </div>
                    </div>
                </div>
            </div> -->